import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      width: "100%",
      display: "flex",
      "flex-direction": "column"
    },
    attrs: {
      id: "productList"
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "margin-bottom": "15px"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "150px",
      "margin-right": "30px"
    },
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect")
    },
    on: {
      change: _vm.changeType
    },
    model: {
      value: _vm.queryParam.productType,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "productType", $$v);
      },
      expression: "queryParam.productType"
    }
  }, _vm._l(_vm.typeList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _c("a-input-search", {
    staticStyle: {
      width: "400px"
    },
    attrs: {
      placeholder: _vm.$t("customerList.searchPl")
    },
    on: {
      pressEnter: _vm.searchProduct,
      search: _vm.searchProduct
    },
    model: {
      value: _vm.queryParam.searchkeyword,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "searchkeyword", $$v);
      },
      expression: "queryParam.searchkeyword"
    }
  })], 1), _c("a-table", {
    staticClass: "components-table-demo-nested",
    attrs: {
      pagination: false,
      rowKey: "id",
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.productList
    },
    on: {
      change: _vm.tableChange
    },
    scopedSlots: _vm._u([{
      key: "rongliang",
      fn: function fn(text, record) {
        return [_c("div", [_vm._v(_vm._s(record.capacity ? record.capacity : "--"))]), _c("div", [_vm._v(_vm._s(record.caseQuantity ? record.caseQuantity : "--"))])];
      }
    }, {
      key: "productNameScopedSlots",
      fn: function fn(text, record) {
        return [record.productType == 1 ? _c("span", [_vm._v(_vm._s(record.productNo ? record.productNo : "--"))]) : _vm._e(), record.productType == 0 ? _c("a", {
          on: {
            click: function click($event) {
              return _vm.editProduct(record);
            }
          }
        }, [_vm._v(_vm._s(record.productNo ? record.productNo : "--"))]) : _vm._e(), _c("br"), record.productName ? _c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(text) + " ")]), record.productType == 0 ? _c("a", {
          staticStyle: {
            "text-decoration": "underline"
          },
          on: {
            click: function click($event) {
              return _vm.editProduct(record);
            }
          }
        }, [_vm._v(_vm._s(text))]) : _c("span", [_vm._v(_vm._s(text))])], 2) : _vm._e(), _c("br"), record.selfDefinedProductFlag == 1 ? _c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm.$t("customerList.selfDefineProduct")))]) : _vm._e()];
      }
    }, {
      key: "erpcontent",
      fn: function fn(text, record) {
        return [_c("div", [_vm._v(" " + _vm._s(record.erpcode ? record.erpcode : "--") + " ")]), _c("div", [_vm._v(" " + _vm._s(record.erpname ? record.erpname : "--") + " ")])];
      }
    }, {
      key: "janCode",
      fn: function fn(text, record) {
        return [_c("span", [_vm._v(" " + _vm._s(record.janCode ? record.janCode : "--") + " ")])];
      }
    }, {
      key: "transport",
      fn: function fn(text, record) {
        return [_c("span", [_vm._v(" " + _vm._s(record.transportName ? record.transportName : "--") + " ")])];
      }
    }, {
      key: "productBrand",
      fn: function fn(text, record) {
        return [_c("span", [_vm._v(" " + _vm._s(record.productBrand ? record.productBrand : "--") + " ")])];
      }
    }, {
      key: "productSourcearea",
      fn: function fn(text, record) {
        return [_c("span", [_vm._v(" " + _vm._s(record.productSourcearea ? record.productSourcearea : "--") + " ")])];
      }
    }, {
      key: "lastBuyDate",
      fn: function fn(text, record) {
        return [_c("span", [_vm._v(" " + _vm._s(record.lastBuyDate ? record.lastBuyDate : "--") + " ")])];
      }
    }, {
      key: "updateTimeScopedSlots",
      fn: function fn(text, record) {
        return _c("span", {}, [[record.lastUpdateTime ? [_vm._v(" " + _vm._s(text.split(" ")[0]) + " "), _c("br"), _vm._v(" " + _vm._s(text.split(" ")[1]) + " ")] : [_vm._v(" -- ")]]], 2);
      }
    }, {
      key: "statusScopedSlots",
      fn: function fn(text, record) {
        return _c("span", {}, [record.specFlag != 2 ? [_vm._v(" -- ")] : [text == 0 ? [_c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm.$t("productList.offTheShelf")))])] : text == 1 ? [_c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(_vm._s(_vm.$t("productList.onTheShelf")))])] : [_c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm.$t("public.overSell")))])]]], 2);
      }
    }, {
      key: "productOnlinedateScopedSlots",
      fn: function fn(text, record) {
        return _c("span", {}, [text ? [_vm._v(" " + _vm._s(text) + " ")] : [_vm._v(" -- ")]], 2);
      }
    }, {
      key: "createTimeErpScopedSlots",
      fn: function fn(text, record) {
        return _c("span", {}, [record.specFlag != 2 ? [_vm._v(" -- ")] : [record.erpCreateTime ? [_vm._v(" " + _vm._s(text.split(" ")[0]) + " "), _c("br"), _vm._v(" " + _vm._s(text.split(" ")[1]) + " ")] : [_vm._v(" -- ")]]], 2);
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "sellPriceSlots"
    },
    slot: "sellPriceSlots"
  }, [_vm._v(" " + _vm._s(_vm.$t("productList.sellPrice")) + _vm._s(_vm.$t("productList.taxIncluded"))), _c("br"), _vm._v(" " + _vm._s(_vm.$t("productList.activityPrice")) + _vm._s(_vm.$t("productList.taxIncluded")) + " ")])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };